<template>
  <app-step>
    <transition name="fade">
    <nights-two-columns v-if="showFlights">
      <template v-slot:left>
        <div class="mb-4">
          <h3 class="heading-3 mb-2">{{ titleStep }}</h3>
          <span class="font-black">{{ name('origin') }} ({{flight.cityCodeFrom}}) - {{ name('destination') }} ({{flight.cityCodeTo}})</span>
        </div>
        <flight-details-modal></flight-details-modal>
      </template>

      <template v-slot:right>
        <div class="flex flex-col gap-2 mt-5 lg:mt-0 2xl:mx-12">
          <div>
            <app-box-booking class="booking-summary">
              <nights-step-details-summary :showPartialPayment="isPackFlight" :flightDetails="flight" :finalPrice="finalPrice" :extraNoPromoPercentage="extraNoPromoPercentage" :totalPassengers="totalPassengers" :itinerary="itinerary">
                <v-btn
                  v-if="flight.definitive"
                  rounded
                  light
                  block
                  elevation="0"
                  color="secondary"
                  class="avm-btn mx-auto"
                  :loading="loading"
                  @click="goToStep(showHotelbedsStep ? 'alojamiento' : 'extras')"
                >
                  {{ $t("shared.continue") }}
                </v-btn>
              </nights-step-details-summary>
            </app-box-booking>
            <app-box-booking-info v-if="isPackFlight"></app-box-booking-info>
          </div>
        </div>
      </template>
    </nights-two-columns>

    <div v-else class="fixed inset-0 h-screen w-full z-50 flex justify-center items-center popup-loading">
      <div class="absolute inset-0 bg-black opacity-50"></div>
      <div class="relative bg-white rounded-2xl max-w-[900px] w-[90%] z-10 flex flex-col justify-center items-center lg:p-12 p-6 shadow-lg m-4">
        <img src="/img/icons/loader/airplane.png" class="w-auto h-20 lg:h-28">
        <p class="mt-8 text-lg lg:text-2.5xl max-w-[500px] text-center">{{ $t("wizard_shared.best_options") }}</p>
        <p class="mt-3 text-md text-turquoiseBlue lg:text-lg text-center">{{ $t("wizard_shared.take_few_seconds") }}</p>
        <!-- Carousel logos -->
        <div class="carousel mt-7 h-12 lg:min-h-20">
          <img :src="currentLogo" alt="logo" class="h-12 lg:h-20 animate-slide-fade" />
        </div>

        <!-- Progress bar -->
        <div class="w-full bg-gray-200 rounded-full h-1.5 mb-2 mt-5">
          <div class="bg-navy h-1.5 rounded-full" :style="{ width: `${progress}%` }"></div>
        </div>
        <div class="text-center mt-8">
          <p class="text-md lg:text-lg">{{ $t("wizard_shared.verifying-prices") }}</p>
          <p class="text-md lg:text-lg">{{ $t("wizard_shared.thanks-for-patience") }}</p>
        </div>
      </div>
    </div>
    </transition>
  </app-step>
</template>

<script>
import { mapGetters } from "vuex";
import { goToStep } from "../mixins";
import {NIGHTS_GET_TOTAL_PRICE, NIGHTS_GET_PASSENGERS_COUNT, NIGHTS_GET_INTERN_FLIGHTS, NIGHTS_GET_IS_PACK_FLIGHT, GET_FLIGHT_SELECTOR, GET_EXTRA_NO_PROMO_PRICE} from "../../../store/nights/getter-types";
import FlightDetails from "./FlightDetails.vue";
import NightsTwoColumns from "../common/NightsTwoColumns.vue";
import BoxSummary from "../common/BoxSummary.vue";
import FlightDetailsModal from './FlightDetailsModal.vue';
import NightsStepDetailsSummary from './components/NightsStepDetailsSummary.vue';

export default {
  mixins: [goToStep],
  components: {
    FlightDetails,
    NightsTwoColumns,
    FlightDetailsModal,
    BoxSummary,
    NightsStepDetailsSummary,
  },
  data() {
    return {
      showHotelbedsStep: window.show_hotelbeds,
      isFixed: false,
      progress: 0,
      logos: [
        '/img/icons/loader/qatar-airways.png',
        '/img/icons/loader/turkish-airlines.png',
        '/img/icons/loader/emirates.png',
        '/img/icons/loader/iberia.png',
        '/img/icons/loader/cathay-pacific.png',
        '/img/icons/loader/klm.png',
        '/img/icons/loader/british-airways.png',
      ],
      currentLogoIndex: 0,
      totalProgress: 100
    }
  },
  computed: {
    ...mapGetters({
      finalPrice: NIGHTS_GET_TOTAL_PRICE,
      totalPassengers: NIGHTS_GET_PASSENGERS_COUNT,
      internFlights: NIGHTS_GET_INTERN_FLIGHTS,
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT,
      flightSelector: GET_FLIGHT_SELECTOR,
      extraNoPromoPercentage: GET_EXTRA_NO_PROMO_PRICE
    }),
    showFlights() {
      return this.initialFlightsLoaded && this.progress > this.totalProgress;
    },
    initialFlightsLoaded() {
      return this.flight.cityCodeFrom && this.flight.cityCodeTo;
    },
    titleStep() {
      switch (this.flightSelector) {
        case 'journey':
          return this.$tc("wizard_shared.select_flight_journey", 1, { prop: this.$t('shared.outbound')})
        case 'return':
          return this.$tc("wizard_shared.select_flight_journey", 1, { prop: this.$t('shared.return')})
        default:
          return this.$tc("wizard_shared.select_flight_journey", 2)
      }
    },
    itinerary() {
      return this.$route.query.itinerary;
    },
    isPackFlight(){
      return ['BKK', 'DPS'].includes(this.flight.cityCodeTo)
    },
    flight() {
      return this.$store.state.nights.flight;
    },
    isRyanair() {
      return true;
      // if (this.$store.state.nights.flight.airlines) {
      //   return this.$store.state.nights.flight.airlines.indexOf("FR") == 0;
      // }
    },
    loading() {
      return this.$store.state.nights.loading;
    },
    destination() {
      return this.$store.state.nights.destination.name;
    },
    flightPrice() {
      return this.$store.state.nights.flight.price;
    },
    totalPassengers() {
      return this.$store.state.nights.passengers.length;
    },
    currentLogo() {
      return this.logos[this.currentLogoIndex];
    },
  },
  methods: {
    datetime(direction, type) {
      return this.flight[`${direction}Flight${type}Time`];
    },
    name(type) {
      const { name } = this.$store.state.nights[type];
      return `${name} `;
    },
    handleScroll() {
      this.isFixed = window.pageYOffset >= 200;
    },
    startProgress() {
      this.progressInterval = setInterval(() => {
        if (this.progress > this.totalProgress) {
          clearInterval(this.progressInterval);
        } else {
          if(this.initialFlightsLoaded){
            this.progress += 5
          }else{
            this.progress += this.progress > 60 ? 0.5 : 1;
          }
        }
      }, this.totalProgress);
    },

    startCarousel() {
      setInterval(() => {
        this.currentLogoIndex =
          (this.currentLogoIndex + 1) % this.logos.length;
      }, 2000);
    },

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.startProgress();
    this.startCarousel();
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_variables.scss";

.flight-details-container {
  background-color: $white;
  padding: 1.8rem 16px;
  border-radius: 15px;
  border: 1px solid $brownGrey;
  @media (min-width: 640px) {
    padding: 1.8rem 2.2rem;
  }
  &:active, &:focus {
    border: 2px solid black;
  }
}

.box-nights-flight-details {
  margin-bottom: 1rem;

  @media (min-width: 1440px) {
    margin-bottom: 2.5rem;
  }
}

.included,
.paid {
  p {
    font-weight: bold;
    font-size: 13px;
    line-height: 1.86;
    text-align: right;
  }
}

.included {

  .v-icon,
  p {
    color: $turquoiseBlue;
  }
}

.paid {
  p:first-child {
    color: #00656d;
  }

  p:last-child {
    color: #9b9b9b;
  }
}

.luggage-title {
  color: #303030;
}

.item {
  border-bottom: 1px solid #9b9b9b;

  &:last-child {
    border-bottom: none;
  }
}

.item-description {
  font-size: 14px;
  line-height: 1.71;
}

.desktop-price {
  span:first-child {
    font-size: 20px;
    font-weight: 900;
    line-height: 1.45;
    color: black;
  }

  span:last-child {
    font-size: 25px;
    font-weight: 900;
    line-height: 1.44;
    color: $turquoiseBlue;
  }
}

.avm-btn {
  margin-top: 0 !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  transition: top 0.4s ease;
}
@keyframes slideFadeInOut {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  20% {
    opacity: 1;
    transform: translateX(0);
  }
  80% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-100%);
  }
}

.animate-slide-fade {
  animation: slideFadeInOut 2s ease-in-out infinite;
}

.carousel {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.animate-fade-in {
  transition: opacity 0.5s ease-in-out;
}

.custom-skeleton {
  height: 200px; /* Ajusta la altura del skeleton loader */
  background-color: rgba(0, 0, 0, 0.05); /* Color de fondo del skeleton */
  border-radius: 12px; /* Bordes redondeados */
}
</style>
